<template>
<div class="MTalentSearch">
    <div class="search_warp">
        <div class="search">
            <form action="/">
                <van-search v-model="paramsData.key" placeholder="请输入搜索关键词" @search="queryData" show-action @cancel="onCancel"></van-search>
            </form>
        </div>
        <div class="filter_box">
            <div class="total">共{{page.rowCount}}个相关岗位</div>
            <div class="filter_div">
                <van-dropdown-menu>
                    <van-dropdown-item title="行业领域" ref="item1">
                        <div class="industry_filter_box">
                            <div class="select_box">
                                <p class="title_text">行业领域</p>
                                <div class="select_type select_type1">
                                    <div v-for="(item, index) in typeList" :key="index" @click="paramsData.jobtypecode01 = item.code" :class="{'active': paramsData.jobtypecode01 === item.code}">{{item.name}}</div>
                                </div>
                                <p class="title_text">行业细分</p>
                                <div class="select_type select_type2">
                                    <div v-for="(item, index) in hyxfList" :key="index" @click="paramsData.jobtypecode02 = item.code" :class="{'active': paramsData.jobtypecode02 === item.code}">{{item.name}}</div>
                                </div>
                            </div>
                            <div class="btn_box">
                                <van-button @click="resetBtn(1)" type="default">重置</van-button>
                                <van-button @click="sureBtn(1)" type="info">确定</van-button>
                            </div>
                        </div>
                    </van-dropdown-item>
                    <van-dropdown-item title="全部筛选" ref="item2">
                        <div class="all_filter_box">
                            <div class="select_box">
                                <p class="title_text">工作地点</p>
                                <div class="select_type select_type1">
                                    <div v-for="(item, index) in gzddList" :key="index" @click="selctCity(item)" :class="{'active': activeJobplace === item.code}">{{item.name}}</div>
                                </div>
                                <p class="title_text">薪资要求</p>
                                <div class="select_type select_type1">
                                    <div v-for="(item, index) in xzyqList" :key="index" @click="selctMoney(item)" :class="{'active': activeAnnualSalary === item.code}">{{item.name}}</div>
                                </div>
                                <p class="title_text">学历要求</p>
                                <div class="select_type select_type1">
                                    <div v-for="(item, index) in xlyqList" :key="index" @click="paramsData.edutype = item.code" :class="{'active': paramsData.edutype === item.code}">{{item.name}}</div>
                                </div>
                                <p class="title_text">工作经验</p>
                                <div class="select_type select_type1">
                                    <div v-for="(item, index) in gzjyList" :key="index" @click="paramsData.exptype = item.code" :class="{'active': paramsData.exptype === item.code}">{{item.name}}</div>
                                </div>
                                <p class="title_text">企业性质</p>
                                <div class="select_type select_type1">
                                    <div v-for="(item, index) in qyxzList" :key="index" @click="paramsData.companytype = item.code" :class="{'active': paramsData.companytype === item.code}">{{item.name}}</div>
                                </div>
                                <p class="title_text">发布时间</p>
                                <div class="select_type select_type1 select_type3">
                                    <div v-for="(item, index) in fbsjList" :key="index" @click="paramsData.timetype = item.code" :class="{'active': paramsData.timetype === item.code}">{{item.name}}</div>
                                </div>
                            </div>
                            <div class="btn_box">
                                <van-button @click="resetBtn(2)" type="default">重置</van-button>
                                <van-button @click="sureBtn(2)" type="info">确定</van-button>
                            </div>
                        </div>
                    </van-dropdown-item>
                </van-dropdown-menu>
            </div>
        </div>
    </div>
    <div class="content_list_warp">
        <pull :pull="pull" :page="page" @getList="getList">
            <NoData v-if="dataList.length === 0"></NoData>
            <div v-else class="job_list_warp">
                <div class="post_item_box" v-for="(item, index) in dataList" :key="index" @click="jobClick(item)">
                    <div class="job_info_box">
                        <van-tag v-if="item.isurgent === 1" style="margin-right: 0.2rem;" color="rgba(245,108,108,0.2)" text-color="#F56C6C">急招</van-tag>
                        <p>{{item.jobname}}</p>
                        <p>{{item.salarytext}}</p>
                    </div>
                    <p class="p_name_text">{{item.companydisplayname}}</p>
                    <div class="tags_box">
                        <div class="tags_div">
                            <p>{{item.jobplace}}</p>
                            <p>{{item.industryname}}</p>
                            <p>{{item.exptypename}}</p>
                        </div>
                        <p class="time_text">{{item.lastupdatetime}}</p>
                    </div>
                </div>
            </div>
        </pull>
    </div>
</div>
</template>

<script>
import Pull from 'views/mobile/components/pull/pull'
import NoData from 'views/mobile/components/noData/noData'
import {getSearchInfoByKey} from 'api/talent'
import type from 'views/talent/components/type.json'
import cityList from 'views/talent/components/cityList.json'
import YearMoneyType from 'views/talent/components/YearMoneyType.json'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'MTalentSearch',
    data() {
        return {
            dataList: [],
            paramsData: {
                key: decodeURI(this.$route.query.key) ? decodeURI(this.$route.query.key) : '',
                jobtypecode01: this.$route.query.jobtypecode01 ? this.$route.query.jobtypecode01 : '',
                jobtypecode02: '',
                jobplace: '',
                salarymin: '',
                salarymax: '',
                edutype: '',
                companytype: '',
                timetype: '',
                exptype: '',
                searchtype: 1
            },
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0,
                rowCount: 0
            },
            pull: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            },
            activeJobplace: this.$route.query.jobplace ? this.$route.query.jobplace : '',
            activeAnnualSalary: '',
            typeList: [{name: '全部', code: '', list: []}, ...type],
            hyxfList: [],
            gzddList: [{name: '全部', code: '', list: []}, ...cityList],
            xzyqList: [{name: '不限', code: '', list: []}, ...YearMoneyType],
            xlyqList: [{name:"不限", code: ""},{name:"本科以上", code: "1"},{name:"硕士以上", code: "2"}],
            gzjyList: [{name:"不限", code: ""},{name:"3年以下", code: "1"},{name:"3-5年", code: "2"},{name:"5-10年", code: "3"},{name:"10年以上", code: "4"}],
            qyxzList: [{name:"不限", code: ""},{name:"国企", code: "1"},{name:"民营企业", code: "2"},{name:"合资", code: "3"},{name:"外资欧美", code: "4"},{name:"外资非欧美", code: "5"},{name:"外企代表处", code: "6"}],
            fbsjList: [{name:"不限", code: ""},{name:"一天以内", code: "1"},{name:"三天以内", code: "2"},{name:"一周以内", code: "3"},{name:"一月以内", code: "4"}],
        }
    },
    mounted() {
        this.setNoDataTip('暂无相关职位')
        this.jobtypecodeTab()
        this.selectJobplace()

        this.getList()
    },
    methods: {
        jobClick(val) {
            this.$router.push({name: 'MJobInfo', query: {'jobid': val.jobinnerid}})
        },
        resetBtn(val) {
            if (val === 1) {
                this.paramsData.jobtypecode01 = ''
                this.paramsData.jobtypecode02 = ''
            } else {
                this.activeJobplace = ''
                this.activeAnnualSalary = ''
                this.selectJobplace()
                this.selectAnnualSalary()

                this.paramsData.edutype = ''
                this.paramsData.companytype = ''
                this.paramsData.timetype = ''
                this.paramsData.exptype = ''
            }
        },
        sureBtn(val) {
            if (val === 1) {
                this.$refs.item1.toggle()
            } else {
                this.$refs.item2.toggle()
            }
            this.getList()
        },
        jobtypecodeTab() {
            for (let i = 0; i < this.typeList.length; i++) {
                if (this.typeList[i].code == this.paramsData.jobtypecode01) {
                    this.hyxfList = [{code: '', name: '全部'}, ...this.typeList[i].list]
                    this.paramsData.jobtypecode02 = ''
                }
            }
        },
        selctCity(val) {
            this.activeJobplace = val.code
            this.selectJobplace()
        },
        selectJobplace() {
            if (this.activeJobplace == '') {
                this.paramsData.jobplace = ''
            } else {
                for (let i = 0; i < cityList.length; i++) {
                    if (cityList[i].code == this.activeJobplace) {
                        this.paramsData.jobplace = cityList[i].name
                    }
                }
            }
        },
        selctMoney(val) {
            this.activeAnnualSalary = val.code
            this.selectAnnualSalary()
        },
        selectAnnualSalary() {
            if (this.activeAnnualSalary == '') {
                this.paramsData.salarymin =  ''
                this.paramsData.salarymax =  ''
            } else {
                for (let i = 0; i < YearMoneyType.length; i++) {
                    if (YearMoneyType[i].code == this.activeAnnualSalary) {
                        this.paramsData.salarymin =  YearMoneyType[i].salarymin
                        this.paramsData.salarymax =  YearMoneyType[i].salarymax
                    }
                }
            }
        },
        queryData() {
            this.getList()
        },
        getList() {
            this.setLoading(true)
            getSearchInfoByKey({
                data: Object.assign({}, this.paramsData, this.page),
                success: data => {
                    if (this.page.page === 1) {
                        this.pull.isLoading = false
                        this.dataList = data.data.content
                    } else {
                        this.dataList = this.dataList.concat(data.data.content)
                    }
                    this.setLoading(false)
                    this.pull.loading = false
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.page.rowCount = data.data.pageinfo.rowCount
                    if (this.page.page === this.page.pageCount) {
                        this.pull.finished = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.pull.error = true
                    this.pull.loading = false
                    this.$toast.fail(data.msg)
                }
            })
        },
        onCancel() {
            this.$router.push({name: 'MTalentIndex'});
        },
        ...mapActions([
            'setLoading',
            'setNoDataTip'
        ])
    },
    filters: {},
    watch: {
        jobtypecode01() {
            this.jobtypecodeTab()
        },
    },
    computed: {
        jobtypecode01() {
            return this.paramsData.jobtypecode01
        },
        ...mapGetters([
            'user'
        ])
    },
    components: {Pull, NoData}
}
</script>

<style lang="scss" type="text/scss">
@import "~common/scss/variable";
.MTalentSearch {
    min-height: 100vh;
    font-family:PingFangSC-Regular,PingFang SC;
    padding-top: 2.03rem;
    box-sizing: border-box;
    .search_warp {
        position: fixed;
        top:0;
        left: 0;
        right: 0;
        background: $c-white;
        z-index: 1;
        .search{
            padding: 0.15rem 0.32rem;
            box-sizing: border-box;
            height: 0.88rem;
            font-size: 0.28rem;
            border-bottom: 0.01rem solid $line;
            .van-search{
                padding: 0;
                height: 0.58rem;
                line-height: 0.58rem;
                .van-search__content{
                    padding-left: 0;
                    border-radius: 0.29rem;
                    overflow: hidden;
                }
                .van-search__action{
                    padding-left:0.4rem;
                    padding-right: 0;
                    color: $c-blue;
                }
                .van-cell{
                    background: #F5F5F5;
                    padding: 0.05rem 0.16rem 0.05rem 0;
                }
                .van-field__left-icon{
                    margin-left: 0.24rem;
                }
            }
        }
        .filter_box {
            overflow: hidden;
            background-color: #FFF;
            height: 0.94rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 0.32rem;
            font-size: 0.26rem;
            .total, .name{
                color: $c-grey;
                line-height: 0.4rem;
            }
            .filter_div {
                width: 4rem;
                .van-dropdown-menu__bar {
                    box-shadow: none;
                }
                .van-dropdown-menu__title {
                    color: #999;
                    font-size: 0.26rem;
                }
                .van-dropdown-menu__title--active {
                    color: #1989fa;
                }
                .btn_box {
                    background-color: pink;
                    .van-button {
                        width: 50%;
                    }
                }
                .industry_filter_box, .all_filter_box {
                    .select_box {
                        padding: 0 0.32rem;
                        .title_text {
                            line-height: 0.8rem;
                            font-size: 0.28rem;
                            color: #666;
                        }
                        .select_type {
                            display: flex;
                            flex-wrap: wrap;
                            .active {
                                background:rgba(46,127,255,0.1);
                                color: #2E7FFF;
                            }
                        }
                        .select_type1 {
                            padding-bottom: 0.12rem;
                            &>div {
                                border-radius: 0.04rem;
                                width: 1.58rem;
                                height: 0.52rem;
                                line-height: 0.52rem;
                                font-size: 0.24rem;
                                color: #666;
                                background-color: #F6F6F6;
                                text-align: center;
                                margin-top: 0.12rem;
                                margin-right: 0.18rem;
                            }
                            &>div:nth-of-type(1), &>div:nth-of-type(2), &>div:nth-of-type(3), &>div:nth-of-type(4) {
                                margin-top: 0.08rem;
                            }
                            &>div:nth-of-type(4n) {
                                margin-right: 0
                            }
                        }
                        .select_type2 {
                            padding-bottom: 0.32rem;
                            &>div {
                                border-radius: 0.04rem;
                                width: 2.16rem;
                                height: 0.52rem;
                                line-height: 0.52rem;
                                font-size: 0.24rem;
                                color: #666;
                                background-color: #F6F6F6;
                                text-align: center;
                                margin-top: 0.12rem;
                                margin-right: 0.18rem;
                            }
                            &>div:nth-of-type(1), &>div:nth-of-type(2), &>div:nth-of-type(3) {
                                margin-top: 0.08rem;
                            }
                            &>div:nth-of-type(3n) {
                                margin-right: 0
                            }
                        }
                        .select_type3 {
                            padding-bottom: 0.32rem;
                        }
                    }
                }
                .all_filter_box {
                    .select_box {
                        height: 6.32rem;
                        overflow-y: scroll;
                    }
                }
            }
        }
    }
    .content_list_warp {
        .van-pull-refresh {
            min-height: 40vh;
        }
        .van-list__finished-text {
            font-size: 0.24rem;
        }
        .job_list_warp {
            padding: 0 0.32rem;
            background-color: #fff;
            .post_item_box {
                padding: 0.32rem 0;
                border-bottom: 0.01rem solid #E5E5E5;
                .job_info_box {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    &>p {
                        font-size:0.32rem;
                        width: 4rem;
                        font-weight: bold;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        word-break: break-all;
                    }
                    &>p:nth-of-type(2) {
                        width: 1.9rem;
                        color: #FF7F04;
                        text-align: right;
                    }
                    .p1 {
                        width: 4.3rem;
                    }
                }
                .p_name_text {
                    line-height: 0.4rem;
                    font-size: 0.28rem;
                    margin-top: 0.12rem;
                    margin-bottom: 0.2rem;
                    color: #999999;
                }
                .tags_box {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .tags_div {
                        display: flex;
                        &>p {
                            color: #5EBDFF;
                            border-radius: 0.04rem;
                            padding: 0 0.1rem;
                            height: 0.4rem;
                            line-height: 0.4rem;
                            text-align: center;
                            font-size: 0.24rem;
                            border: 0.02rem solid #5EBDFF;
                            max-width: 1.3rem;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            word-break: break-all;
                        }
                        p + p {
                            margin-left: 0.2rem;
                        }
                    }
                    .time_text {
                        line-height: 0.4rem;
                        font-size: 0.28rem;
                        color: #999999;
                    }
                }
            }
            .post_item_box:nth-last-of-type(1) {
                border-bottom: none;
            }
        }
    }
    .noData{
        height: calc(100vh - 2.03rem);
        background: $c-white;
    }
}
</style>